export default __webpack_public_path__ + "static/media/qipBanner.9fd85ee9.svg";